import React, { memo } from 'react';

interface SelectInputProps {
    label: string;
    options: Array<{label: string, value: string}>;
    selectedValue: string;
    placeholder?: string;
    onChange: (value: string) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({ label, options, selectedValue, onChange }) => {
    console.log('------------     select  input    ------------------', label, options, selectedValue);

    return (
        <div className="w-full flex flex-col mb-[15px]">
            <label className="block text-base mb-[5px]" htmlFor="selectInput">
                {label}
            </label>
            <select
                value={selectedValue}
                onChange={(e) => onChange(e.target.value)}
                className="light-border p-2 rounded"
                style={{
                    border: "1px solid #ddd",
                    backgroundColor: 'white',
                }}
            >
                {options.map((option, index) => (
                    <option key={index} value={option.value} selected={option.value === selectedValue}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default memo(SelectInput);